export default function faToEnNum(num: string | number | undefined): string {
  const str = String(num ?? '')
  return str.replace(/[۰-۹]/g, function (d) {
    return String.fromCharCode(d.charCodeAt(0) - 1728)
  })
}
